<template>
    <div>
        <div class="content-box mr60">
            <el-form ref="form" label-width="120px" :model="formItem" :rules="rules" class="form-wrap">
                <el-form-item :style="{marginBottom: '4px'}">
                    <span :style="{fontSize: '12px'}">撤回后工单无效，可以在“工单管理-已撤回”中找到</span>
                </el-form-item>
                <el-form-item label="撤回：" prop="app_type">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="最多输入20个字" v-model.trim="formItem.name" clearable maxlength="20" show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>

<!-- 工单管理 待指派 撤回弹框-->
<script>

    import API from '@/api/workOrder/conf.js';
    export default {
        name: "withdrawModal",
        data(){
            return {
                formLoading:false,
                formItem:{
                    group:'',
                },
                rules:{

                },
            }
        },
        mounted(){
        },
        methods:{
            submitModal(){
                console.log('submitModal');
            },
            hideModal(){
                this.$emit('close');
            },
        }
    }
</script>

<style scoped>

</style>
